import http from '../utils/http';
import i18n from '@/main';
const baseUrl = '/alertas';

export default {
    findAlertas(
        idAreaMonitorada = 17,
        filtro,
        { paginaAtual = 0, tamPagina = 99999 }
    ) {
        return http.post({
            url:
                baseUrl +
                `/areamonitorada/${idAreaMonitorada}?page=${paginaAtual}&size=${tamPagina}`,
            data: filtro,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoAlertas')
        });
    },

    getResumoAlertas() {
        return http.get({
            url: baseUrl + `/resumo`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDosAlertas')
        });
    },
    getResumoAlertasAreaMonitorada(idAreaMonitorada) {
        return http.get({
            url: baseUrl + `/resumo/areamonitorada/${idAreaMonitorada}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDosAlertas')
        });
    },

    findTotalAlertas(id) {
        return http.get({
            url: baseUrl + `/total/${id}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoDadosDosAlertas')
        });
    },

    findAlertaById(idAlerta) {
        return http.get({
            url: baseUrl + `/${idAlerta}`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoAlerta')
        });
    },

    findAreaMonitoradaWithAlerta() {
        return http.get({
            url: baseUrl + `/areasMonitoradas`,
            lockScreen: false,
            lockMessage: i18n.t('mensagens.sistema.buscandoAreaMonitorada')
        });
    },

    findCamadas(idAreaMonitorada) {
        return http.get({
            url: baseUrl + `/areasMonitoradas/${idAreaMonitorada}/camadas`,
            lockScreen: true,
            lockMessage: i18n.t('mensagens.sistema.buscandoAlertas')
        });
    },

    buscarTotalizadores() {
        return http.get({
            url: baseUrl + `/totalizadores`,
            lockScreen: false
        });
    }
};
